import { format as formatDateFns } from 'date-fns';
import { FormatDateXType } from './FormatDateXType';
import nlBE from 'date-fns/locale/nl-BE';
import fr from 'date-fns/locale/fr';
import { LanguageOption } from 'gen/ApiClient';

export function formatDateX(date: Date | undefined | null | string | number, format: FormatDateXType = 'dd/MM/yyyy', language: LanguageOption = 'nl'): string {
	if (date === undefined || date === null) {
		return '';
	} else {
		const locale = language === 'fr' ? fr : nlBE;
		return formatDateFns(date instanceof Date ? date : new Date(date), format, { locale: locale });
	}
}
